var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,_vm._b({tag:"component",class:_vm.inputClass,attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":_vm.text},on:{"input":_vm.update}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }